var _circle, _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntegrationServiceIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10,
    r: 10,
    fill: "#0067DF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 20,
    height: 20,
    rx: 3,
    fill: "#0067DF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_368_37142)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.7221 6.66655H9.38876V5.55543H7.7221C6.80162 5.55543 6.05543 6.30163 6.05543 7.2221V8.88877H7.16654V7.2221C7.16654 6.91528 7.41527 6.66655 7.7221 6.66655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2777 13.3332H11.611V14.4443H13.2777C14.1981 14.4443 14.9443 13.6981 14.9443 12.7777V11.111H13.8332V12.7777C13.8332 13.0845 13.5845 13.3332 13.2777 13.3332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3371 9.83715L9.22603 10.9483L8.44036 10.1626L9.55147 9.05147L10.3371 9.83715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4483 10.9483L10.3371 12.0594L9.55147 11.2737L10.6626 10.1626L11.4483 10.9483Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.55938 13.726L6.44827 14.8372L5.6626 14.0515L6.77371 12.9404L7.55938 13.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.79877 12.6136L7.85083 10.6657L6.81185 11.7046L8.75979 13.6526L9.79877 12.6136ZM7.85083 9.09431L6.02617 10.919C5.59225 11.3529 5.59226 12.0564 6.02617 12.4903L7.97411 14.4383C8.40803 14.8722 9.11155 14.8722 9.54546 14.4383L11.3701 12.6136L7.85083 9.09431Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4404 6.27371L14.5515 5.1626L15.3372 5.94827L14.226 7.05938L13.4404 6.27371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4278 7.34373L13.3763 9.2922L14.4156 8.25282L12.4672 6.30435L11.4278 7.34373ZM13.3763 10.8635L15.2013 9.0385C15.6352 8.60458 15.6352 7.90107 15.2013 7.46715L13.2528 5.51868C12.8189 5.08476 12.1154 5.08476 11.6815 5.51868L9.85644 7.34373L13.3763 10.8635Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_368_37142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(5.5 5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationServiceIcon);
export default __webpack_public_path__ + "static/media/integrationServiceIcon.a1ca63f22e2593acce9c5d90bccb235c.svg";
export { ForwardRef as ReactComponent };